export const postItemStyles = {
  container: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    gap: '12px',
  },
  headerContainer: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  profileContainer: { display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '12px' },
  postDateContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
    gap: '12px',
  },
  date: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '150%',
    color: '#6E707A',
    cursor: 'pointer',
  },
  avatarContainer: { display: 'flex', height: '40px', width: '40px', position: 'relative' },
  greenDot: {
    position: 'absolute',
    display: 'flex',
    width: '10px',
    height: '10px',
    backgroundColor: '#379552',
    border: '2px solid #FFFFFF',
    left: '-4px',
    top: '-4px',
    borderRadius: '50%',
    zIndex: '10',
  },
  avatar: { width: '40px', height: '40px', borderRadius: '8px' },
  defaultAvatarContainer: {
    display: 'flex',
    backgroundColor: '#EDEFF7',
    borderRadius: '4px',
    width: '40px',
    height: '40px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  defaultAvatar: {
    fontFamily: 'Inter',
    color: '#6E707A',
    fontSize: '14px',
    fontStyle: 'normal',
    lineHeight: '146%',
    fontWeight: '500',
    '-webkit-user-select': 'none',
    '-ms-user-select': 'none',
    'user-select': 'none',
  },
  userInfoContainer: { display: 'flex', flexDirection: 'column', gap: '3px' },
  userName: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '122%',
    alignItems: 'center',
    display: 'flex',
    color: '#23252F',
  },
  userRole: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '150%',
    alignItems: 'center',
    display: 'flex',
    color: '#6E707A',
  },
  postContentContainer: {
    display: 'flex',
    width: '100%',
    padding: '8px 12px',
    border: '1px solid #F3F4F9',
    borderRadius: '8px',
    fontFamily:
      "'Inter', 'Apple Color Emoji', 'Segoe UI Emoji', 'Noto Color Emoji', 'Twemoji', sans-serif",
    '& p, a': {
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: 400,
      margin: '0',
      color: '#23252F',
      wordBreak: 'break-word',
      minHeight: '20px',
    },
    '& p': {
      color: '#424550',
    },
    '& span': {
      fontFamily: 'Inter',
      fontStyle: 'normal',
      fontWeight: '600',
      fontSize: '14px',
      lineHeight: '146%',
      color: '#4D6EF5',
    },
  },
  actionsContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  likeReplyContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    gap: '12px',
  },
  actionBtn: {
    padding: '0',
    fontFamily: 'Inter',
    fontStyles: 'normal',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '150%',
    color: '#23252F',
    textTransform: 'unset',
  },
  postInfoContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '6px',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  postInfoBtn: {
    textTransform: 'unset',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '150%',
    color: '#8C8F9D',
    padding: '0',
    minWidth: 'unset',
  },
  likeInfo: {
    width: '100%',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '10px',
    lineHeight: '148%',
    color: '#FFFFFF',
  },
  hoverUnderline: {
    textDecoration: 'none',
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontSize: 'inherit',
    lineHeight: 'inherit',
    letterSpacing: 'inherit',
    color: 'inherit',
    margin: 0,
    padding: 0,
    '&:hover': {
      textDecoration: 'underline',
      color: '#23252F',
    },
  },
  withoutUnderline: {
    textDecoration: 'none',
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontSize: 'inherit',
    lineHeight: 'inherit',
    letterSpacing: 'inherit',
    color: 'inherit',
    margin: 0,
    padding: 0,
  },
  circularProgress: {
    margin: ' auto',
  },
  loaderContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '36px',
  },
  usersIconBox: { display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' },
  iconButton: {
    width: '20px',
    height: '20px',
    padding: 0,
    '& svg': {
      width: '20px',
      height: '20px',
    },
  },
};
